import config from '../../config';
import { HTTP } from  '../../http';
import moment from 'moment';
export default {
    getAll: (keywords, eventId, startDate, endDate) => {
        startDate = moment(startDate);
        startDate.set({h: 0, m: 0, s: 0});
        endDate = moment(endDate);
        endDate.set({h: 23, m: 59, s: 59});
        let s = eventId == null || eventId == '' ? '' : `&eventId=${eventId}`;
        let startDateFormatted = startDate.format('YYYY-MM-DDTHH:mm:ss');
        let endDateFormatted = endDate.format('YYYY-MM-DDTHH:mm:ss');
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.cashiersUri.concat(`?keywords=${keywords}${s}&startDate=${startDateFormatted}&endDate=${endDateFormatted}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}